module.exports = __webpack_public_path__ + "static/img/Dragons.255ca29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dragons.svg
// module id = OLWw
// module chunks = 1